import { useEffect, useState } from 'react'
import { Link, Navigate, useNavigate } from 'react-router-dom'
import AuthForm from '../components/AuthForm'
import { useAuth } from '../context/AuthContext'
import { api } from '../services/api'

function SignupPage() {
  const { user, signup } = useAuth()
  const navigate = useNavigate()
  const [askAccess, setAskAccess] = useState(false)

  useEffect(() => {
    let active = true
    api
      .get('/auth/signup-options')
      .then((data) => active && setAskAccess(Boolean(data.accessPasswordRequired)))
      .catch(() => {})
    return () => {
      active = false
    }
  }, [])

  const destination = (account) => (account.profileLevel >= 3 ? '/code' : '/onboarding')

  if (user) {
    return <Navigate to={destination(user)} replace />
  }

  const handleSubmit = async (email, password, accessPassword) => {
    const account = await signup(email, password, accessPassword)
    navigate(destination(account))
  }

  return (
    <AuthForm
      title="Sign up"
      submitLabel="Create account"
      onSubmit={handleSubmit}
      note="Use at least 6 characters."
      askAccess={askAccess}
      footer={
        <>
          Have an account? <Link to="/login">Log in</Link>
        </>
      }
    />
  )
}

export default SignupPage
